import { resetGlobalSlice, setGlobalIsLoading } from 'reducers/globalSlice';
import { resetFileUploadSlice } from 'reducers/fileUploadSlice';
import { resetLaancSlice } from 'reducers/laancSlice';
import { resetManageTablesSlice } from 'reducers/manageTablesSlice';
import { resetMapSlice } from 'reducers/mapSlice';
import { resetMissionSlice } from 'reducers/missionSlice';
import { resetReportsSlice } from 'reducers/reportsSlice';
import { resetRolesSlice } from 'reducers/rolesSlice';
import { setAccountData, setCurrentAccountId } from 'reducers/userAuthSlice';
import { resetStreamingSlice } from 'reducers/streamingSlice';
import {
	INTENDED_LOCATION,
	RECENT_SEARCH,
	SEARCH_FILTERS,
	SELECTED_SEARCH_TYPE
} from 'constants/localStorageConstants';

/**
 * dispatch helper
 * @execute TabAirSpace Component
 * @function dispatchToStore
 * --- Nov 8 2021 - all use removed in favor of useDispatch hook ----
 */
export const dispatchToStore = (type, payload) => (dispatch, getState) => {
	dispatch({ type: type, payload: payload });
	return getState();
};

/**
 * set isLoading to true on API call, then set to false after response
 * @function setLoadingStateApiCall
 * @param apiFunction
 * @return response object
 */
export const setLoadingStateApiCall = action => async dispatch => {
	dispatch(setGlobalIsLoading(true));
	const res = await action;
	dispatch(setGlobalIsLoading(false));
	return res;
};

export const resetAppStateOnSwitchAccount = id => dispatch => {
	//set account id to the selected account
	dispatch(setAccountData(null));
	dispatch(setCurrentAccountId(id));

	//Clear all other pieces of state
	dispatch(resetFileUploadSlice());
	dispatch(resetGlobalSlice());
	dispatch(resetLaancSlice());
	dispatch(resetManageTablesSlice());
	dispatch(resetMapSlice());
	dispatch(resetMissionSlice());
	dispatch(resetReportsSlice());
	dispatch(resetRolesSlice());
	dispatch(resetStreamingSlice());

	const clearLocalStorageItems = [
		RECENT_SEARCH,
		SEARCH_FILTERS,
		INTENDED_LOCATION,
		SELECTED_SEARCH_TYPE
	];

	for (const key of clearLocalStorageItems) {
		if (localStorage.getItem(key)) {
			localStorage.removeItem(key);
		}
	}
};
